import { TreeEntitySelect } from '../../shared/components/TreeEntitySelect';
import { resources } from '../../core/services/resources';
import type { LineOfBiz } from '../../core/types/data-models';

interface LineOfBizSelectProps {
  /** Currently selected LOB id. `null` / `undefined` means no selection. */
  value: number | null | undefined;
  onChange: (id: number | null) => void;
  label?: string;
  helperText?: string;
  required?: boolean;
  /**
   * Optional id to omit along with its entire subtree — used when picking
   * a parent so an LOB can't become a descendant of itself.
   */
  excludeId?: number;
}

/**
 * Picker for an existing LineOfBiz, rendered as an indented tree because
 * LOBs themselves form a parent → child hierarchy (`parentId`). Thin
 * wrapper over `TreeEntitySelect<LineOfBiz>` — the field name on the row
 * is `parentId`, not `parentBrandId`/`commonCategoryId`, which is why
 * the wrapper exists.
 */
export function LineOfBizSelect({
  value,
  onChange,
  label = 'Parent line of business',
  helperText = 'Leave empty for a root line of business.',
  required,
  excludeId,
}: LineOfBizSelectProps) {
  return (
    <TreeEntitySelect<LineOfBiz>
      cacheKey={['lines-of-business', 'select']}
      service={resources.linesOfBusiness}
      parentIdField="parentId"
      label={label}
      helperText={helperText}
      required={required}
      value={value}
      onChange={onChange}
      excludeSubtreeOf={excludeId}
    />
  );
}
